import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { confirmationBase32EncodedCodeValidator, userEmailValidator, } from '#validation';
import { userIdentitySchema } from '../identity/identity';
const initiatePasswordResetSchema = z.object({
    email: userEmailValidator,
});
export class InitiatePasswordResetDto extends createZodDto(initiatePasswordResetSchema) {
}
const passwordResetEmailVerificationSchema = z.object({
    email: userEmailValidator,
    verificationCode: confirmationBase32EncodedCodeValidator({
        requiredError: 'emailVerification.code.required',
        lengthError: 'emailVerification.code.length',
    }),
});
export class PasswordResetVerificationDto extends createZodDto(passwordResetEmailVerificationSchema) {
}
const resetPasswordSchema = userIdentitySchema;
export class ResetPasswordDto extends createZodDto(resetPasswordSchema) {
}
